/**
 * The freeze of the 2014 schemas (1.0b deliverable 16; CS r6a deliverable 181). StatBlockV1,
 * SpellV1 and ItemV1 were frozen by 1.0b; CharacterV1 by CS r6a, from 2.G s1's answers to p0-4b's
 * five 2.0b questions. The sheet and card DTOs of contracts carry them, so a change is additive
 * only, through a contract steward round. Each frozen schema is at version 1; a stored row's data
 * is read at that version.
 *
 * CharacterV1's freeze added two optional fields: `effects` (active effects in 2.G deliverable
 * 6's shape; DECISIONS 216 ruling 1) and an item's `ddbId` (ruling 6). What stays out, each a
 * `FOUNDRY_COVERAGE` drop with its reason, so it is never counted as unmapped (2.G s1's freeze
 * answers 3 and 4; a count of non-default values in the GM's files decides whether one joins
 * later, additively):
 * - roll limits and modes (other than a skill's `rollMode`), death-save and concentration roll
 *   settings and the concentration ability, and tool roll settings: no derive reads them;
 * - weapon mastery: a 2024 rule;
 * - a loot item's `system.type.value`: no loot block yet;
 * - conditions beyond the 2014 fifteen: kept in `traits.ci.custom`, no schema change;
 * - module flags and the macro's derived snapshot (DECISIONS 213 rulings 3 and 4): the raw asset
 *   and `actor_sheet.foundry_snapshot` hold them, never the sheet.
 */
export const STATBLOCK_SCHEMA_VERSION = 1;
export const SPELL_SCHEMA_VERSION = 1;
export const ITEM_SCHEMA_VERSION = 1;
export const CHARACTER_SCHEMA_VERSION = 1;
export const DND5E_SCHEMA_STATUS = Object.freeze({
    statblock: 'frozen',
    spell: 'frozen',
    item: 'frozen',
    character: 'frozen',
});
//# sourceMappingURL=freeze.js.map